import { defineMessages } from 'react-intl'

export default defineMessages({
  'picker.title': {
    id: 'components.PhoneInput.picker.title',
    defaultMessage: ' ',
    description: '选择国家/地区列表的title',
  },
  'input.placeholder': {
    id: 'components.PhoneInput.input.placeholder',
    defaultMessage: 'Mobile',
    description: '手机号码输入框的placeholder',
  },
})
